import { restClient } from '../../core/network/restClient';

const PUBLIC_ORDER_TRACKING_PATH = '/api/v1/public/order-tracking';

// Khác tra cứu bảo hành: ở đây "sai mã đơn" và "sai số điện thoại" là 2 thông báo khác nhau do BE
// trả về, nên không nuốt lỗi thành kết quả rỗng — cứ ném RestError lên cho form tự phân loại
// và hiện đúng câu của BE.
export const fetchPublicOrderTracking = async ({ orderCode, phoneNumber } = {}, { signal } = {}) => {
  const { data } = await restClient.get(PUBLIC_ORDER_TRACKING_PATH, {
    params: { order_code: orderCode, phone_number: phoneNumber },
    signal,
  });
  return data;
};
